module.exports = __webpack_public_path__ + "img/kitkitphoto3.3d577c80.jpg";